import * as React from 'react';
import {connect} from "react-redux";
import _ from 'lodash';
import {COMPANIES_SORT_BY} from '../../../Config/appConfig';
import {CompanyHistory} from '../../../Config/dataModel';
import userManagementDispatch from '../../../ReduxRequests/Dispatch/userManagementDispatch';
import userManagementState from '../../../ReduxRequests/State/userManagementState';
import CloseButton from '../../Custom/CloseButton';
import Table from '../../Custom/Table';
import util from '../../../Util/util';

interface SubagentListProps {
    fetchSubagentHistory: () => void,
    subagentHistory: CompanyHistory[]
}

interface SubagentListState {
    list: CompanyHistory[],
    sortBy: string,
    asc: boolean
}

class SubagentList extends React.Component <SubagentListProps, SubagentListState> {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            sortBy: '',
            asc: true
        };
    }

    public componentDidMount() {
        this.props.fetchSubagentHistory();
    }

    public componentWillReceiveProps(nextProps) {
        if (nextProps.subagentHistory !== this.props.subagentHistory) {
            this.setState({
                list: nextProps.subagentHistory
            });
        }
    }

    public getHeader() {
        return [
            {title: 'Sub-agent Company', cols: 8, sortBy: COMPANIES_SORT_BY.COMPANY},
            {title: 'Relevant Date', cols: 4, sortBy: COMPANIES_SORT_BY.LAST_ACTIVE}
        ];
    }

    public getRows() {
        let rows = [];
        for (let i = 0; i < this.state.list.length; i++) {
            const data = this.state.list[i];
            rows.push([
                <span key={i} className={data.destroyTime ? "disabled cmObliqueText" : ""}>{data.displayName}</span>,
                <div key={i} className="contactTableViewCol">
                    <div className="contactTableViewCellLabel">{data.destroyTime ? "De-activated by" : "Invitation sent on"}</div>
                    <div className={data.destroyTime ? " disabled cmObliqueText" : ""}>
                        {util.getFormattedDate(data.destroyTime ? data.destroyTime : data.createTime)}
                    </div>
                </div>,
            ]);
        }
        return rows;
    }

    clickSort(sortBy: string) {
        const asc = this.state.sortBy === sortBy ? !this.state.asc : true;
        this.setState({
            list: _.orderBy(this.state.list, sortBy, (sortBy === COMPANIES_SORT_BY.LAST_ACTIVE ? !asc : asc) ? 'asc' : 'desc'),
            sortBy,
            asc
        });
    }

    public render() {
        return (
            <div className="cmHorCenter cmFormContainer">
                <div className="cmFormTitleHeader">
                    <div className="cmFormTitle">View Sub-agent list</div>
                    <CloseButton/>
                </div>
                <Table
                    header={this.getHeader()}
                    rows={this.getRows()}
                    clickable={false}
                    noRecords="No Sub-agents are linked."
                    sortBy={this.state.sortBy}
                    clickSort={(sortBy) => this.clickSort(sortBy)}/>
            </div>
        );
    }
}

export default connect(userManagementState, userManagementDispatch)(SubagentList);



// WEBPACK FOOTER //
// ./src/Components/Contact/CompanyList/SubagentList.tsx